<template>
  <div style="color: #fff" class="rightBar">
    <v-drawer
      class="right-drawer"
      :class="curcode === 'zb' ? '' : 'hastop'"
      :direction="'right'"
      :width="'26%'"
    >
      <div class="animated fadeInRightBig" style="height: 100%; width: 100%">
        <bar-card class="lefts-t" :bg="'border2'" v-if="curcode === 'zb'">
          <v-title>
            <el-popover
              placement="bottom"
              title=""
              width="80"
              trigger="hover"
              :content="showmsg"
            >
              <div slot="reference">
                {{ sjObj.name }}
              </div>
            </el-popover>
          </v-title>
          <div class="panelContent">
            <div class="tableTitle flex">
              <div style="width: 35%">出口企业</div>
              <div style="width: 10%">品类</div>
              <div style="width: 10%">出口<br />方式</div>
              <div style="width: 13%">累计出口(吨)</div>
              <div style="width: 32%">价格(元/公斤)</div>
            </div>
            <div class="tableBody">
              <vue-seamless-scroll
                :data="tableData"
                style="height: 100%"
                :class-option="optionHover"
              >
                <ul>
                  <li
                    v-for="(item, index) in tableData"
                    :key="index"
                    class="flex content"
                  >
                    <div style="width: 35%">{{ item.name }}</div>
                    <div style="width: 10%">
                      {{ item.breed }}
                    </div>
                    <div style="width: 10%">
                      {{ item.transport }}
                    </div>
                    <div style="width: 13%">
                      {{ item.total }}
                    </div>
                    <div style="width: 32%">
                      <span class="money-num">{{ item.price }}</span>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </bar-card>
        <bar-card class="lefts-m" :bg="'border2'" v-if="curcode === 'zb'">
          <v-title>{{ sjObj.name02 }}</v-title>
          <div class="panelContent">
            <div class="tableTitle flex">
              <div style="width: 33%">地区</div>
              <div style="width: 33%">品种</div>
              <div style="width: 34%">价格(元/公斤)</div>
            </div>
            <div class="tableBody">
              <vue-seamless-scroll
                style="height: 100%"
                :data="retailPriceList"
                :class-option="optionHover0"
              >
                <ul style="height: 100%">
                  <li
                    v-for="(item, index) in retailPriceList"
                    :key="index"
                    class="flex content"
                  >
                    <div style="width: 33%">{{ item.area }}</div>
                    <div style="width: 33%">{{ item.breed }}</div>
                    <div style="width: 34%">
                      <span class="money-num">{{ item.price }}</span>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </bar-card>
        <bar-card class="lefts-m2" :bg="'border2'">
          <v-title>{{ sjObj.name03 }}</v-title>
          <div class="panelContent">
            <!-- <div class="ls-box">
              <div v-for="item in lsList" :key="item.id" class="ls-item">
                <div class="ls-title">{{ item.name }}</div>
                <div class="ls-value">{{ item.value }}({{ item.unit }})</div>
              </div>
            </div> -->
            <div class="tableTitle flex">
              <div style="width: 33%">区域</div>
              <div style="width: 33%">数量/棵</div>
              <div style="width: 34%">重量/千克</div>
            </div>
            <div class="tableBody" v-if="lsList.length > 0">
              <vue-seamless-scroll
                style="height: 100%"
                :data="lsList"
                :class-option="optionHover0"
              >
                <ul style="height: 100%">
                  <li
                    v-for="(item, index) in lsList"
                    :key="index"
                    class="flex content"
                  >
                    <div style="width: 33%">{{ item.area }}</div>
                    <div style="width: 33%">{{ item.zl }}</div>
                    <div style="width: 34%">
                      <span class="money-num">{{ item.sl }}</span>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </bar-card>
        <!-- delete <bar-card class="lefts" :bg="'border2'" v-if="curcode === 'zb'">
          <v-title>市场零售价格排行榜</v-title>
          <div class="panelContent">
            <div class="tab-box flex">
              <div
                v-for="(item, index) in jgTypeList"
                :key="index"
                class="tab-item"
                :class="{ active: active === index }"
                @click="changeType(index)"
              >
                <span>{{ item }}</span>
              </div>
            </div>
            <div class="chart" ref="lineChart" />
          </div>
        </bar-card> -->
        <bar-card class="lefts" :bg="'border2'">
          <v-title>{{ sjObj.name04 }}</v-title>
          <div class="panelContent">
            <qxzb ref="xsqx"></qxzb>
          </div>
        </bar-card>
        <bar-card v-if="curcode !== 'zb'" class="lefts lefts2" :bg="'border2'">
          <v-title>品牌建设</v-title>
          <div class="panelContent">
            <right-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
// import rightTop from "./rightBar/rightTop";
import { loadBarChart } from "./chart/chartData";
import { get } from "@/api/index";
import rightBot from "./rightBar/rightBot";
import qxzb from "./components/qxzb";
import { getDataMarketPriceRank, getDataKindPriceRank } from "@/api/schj";
// import { timerMixin } from "@/util/mixin/timerMixin";
export default {
  //   mixins: [timerMixin],
  components: {
    // rightTop,
    qxzb,
    rightBot,
  },
  computed: {
    curcode() {
      this.updEc();
      return this.$store.state.schj.code;
    },
    optionHover() {
      return {
        step: 0.5, //数值越大速度滚动越快
        limitMoveNum: 3,
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
    optionHover0() {
      return {
        step: 0.5, //数值越大速度滚动越快
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, //开启数据实时监控刷新dom
        singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        waitTime: 1000, //单步运动停止的时间(默认值1000ms)
      };
    },
  },

  methods: {
    updEc() {
      this.$refs.xsqx && this.$refs.xsqx.updEc();
    },
    initChart() {
      //价格排行-柱状图
      this.lineChart = this.$echarts.init(this.$refs.lineChart);
      this.getRankData();
      this.startTimer();
      window.addEventListener("resize", () => {
        // this.chart.resize();
        this.lineChart.resize();
      });
    },
    getRankData() {
      if (this.active === 0) {
        getDataMarketPriceRank().then((res) => {
          if (res) {
            let xData = res.data.map((ele) => {
              return ele.name;
            });
            let bfData = res.data.map((ele) => {
              return ele.price;
            });

            xData = xData.reverse();
            bfData = bfData.reverse();

            loadBarChart(
              this.lineChart,
              xData,
              bfData,
              this.jgTypeList[this.active],
              "价格"
            );
          }
        });
      } else {
        getDataKindPriceRank().then((res) => {
          if (res) {
            let xData = res.data.map((ele) => {
              return ele.name;
            });
            let bfData = res.data.map((ele) => {
              return ele.price;
            });

            xData = xData.reverse();
            bfData = bfData.reverse();

            loadBarChart(
              this.lineChart,
              xData,
              bfData,
              this.jgTypeList[this.active],
              "价格",
              "元/公斤"
            );
          }
        });
      }

      window.addEventListener("resize", () => {
        this.lineChart.resize();
      });
    },
    runs() {
      let len = this.jgTypeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getRankData();
      if (clearT) {
        this.startTimer();
      }
    },
  },
  data() {
    const year = new Date().getFullYear();

    return {
      lineChart: null,
      jgTypeList: ["市场", "品种"],
      active: 0,
      tableData: [],
      showmsg: "2023年累计出口3000吨",
      retailPriceList: [],
      lsList: [],
      zslVal: "",
      zLVal: "",
      sjObj: {
        name: "出口市场行情(" + year + ")",
        name02: "市场零售价格(" + year + ")",
        name03: "荔树定制情况(" + year + ")",
        name04: "电商销售占比(" + year + ")",
      },
    };
  },
  mounted() {
    // this.initChart();
    // get data
    get("../ywtg_service/api/getyztdata").then((res) => {
      // save to vuex
      const data = res.data;
      try {
        const {
          exportPriceList,
          retailPriceList,
          marketPriceList,
          logisticsStateList,
        } = data;
        this.$store.dispatch("schj/setDatas", {
          marketPriceList,
          logisticsStateList,
        });
        if (exportPriceList instanceof Array) {
          this.tableData = exportPriceList;
          // 计算总数
          // const all = exportPriceList.reduce((pre, cur) => {
          //   console.log("pre, cur", pre);
          //   return pre + cur.total;
          // }, 0);
          const totalSum = exportPriceList.reduce(
            (accumulator, currentValue) => {
              return accumulator + parseFloat(currentValue.total);
            },
            0
          );
          this.showmsg = `2023年累计出口${totalSum}吨`;
          this.retailPriceList = retailPriceList;
        }
      } catch (err) {
        console.log(err);
      }
    });
    // get 荔树data
    this.lsList = [];
    get("/api/dp/visual/queryList?code=dzqk").then((res) => {
      if (res.data instanceof Array && res.data.length > 0) {
        // const data = res.data[0];

        res.data.map((e) => {
          e.sl = e.lzcl;
          e.area = e.qy;
          e.zl = e.dzl;
          this.lsList.push(e);
        });
      }
    });
  },
};
</script>

<style lang="stylus" scoped>
.ls-box
  display flex
  align-items center
  height 100%
  padding 0 30px

  .ls-title
    color #02F6FD
    margin 10px 0 10px 15px

  .ls-value
    color yellow
    text-align center

  .ls-item
    flex 1
    background url('~images/index/cyzl/c_bg.png') no-repeat
    background-size 100% 100%
    max-height 80px
    min-height 70px
    margin-right 15px
    font-size 16px

    &:last-child
      margin-right 0

.right-drawer.hastop
  >>>.side
    top calc(20% + 105px)

.panelContent
  height calc(100% - 43px)
  color #fff
  overflow hidden

  .tab-box
    position absolute
    top 40px
    right 2%
    z-index 999

    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer

      &:before
        content ' '
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)

    .tab-item.active
      color #0e9cff

      &:before
        background #0e9cff

  .tableTitle
    background transparent
    color #fff
    padding 0
    font-size 13px
    text-align center
    justify-content center

  .tableBody
    height calc(100% - 24px)
    overflow hidden
    font-size 12px

    .scroll-content
      position relative
      transition top .1s

    .content
      padding 0px 5px
      line-height 40px
      color #fff
      cursor pointer
      text-align center

    .money-num
      font-size 14px
      color #FCDC00

    .sale-num
      font-size 14px
      color #02c8f4

    .content:nth-child(2n+1)
      line-height 40px
      background #003c5e

.lefts-t
  height calc(20% + 30px)
  margin-bottom 10px

.lefts-m
  height calc(35% - 50px)
  margin-bottom 10px

.lefts-m2
  height calc(20% - 10px)
  margin-bottom 10px

.lefts
  height calc(25% - 10px)
  // height 40%
  margin-bottom 10px

.lefts2
  height calc(65% - 10px)

@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
